<template>
 <v-dialog v-model="dialogManageGroup" persistent max-width="500px">
  <v-card style="border-radius:20px;">
  <v-card tile >
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai"><v-icon color="white">fas fa-users</v-icon>&nbsp;&nbsp;{{$t('Dialog.group.headerSetting')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeManageGroup">
          <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
  <v-card-text style="height: 350px;">
    <!-- {{detail}} -->
    <v-container grid-list-md>
          <v-layout wrap>
            <v-flex sm12 md12 style="display: flex; justify-content: center;">
              <v-badge color="orange darken-1" overlap bottom  style="    height: 22vh !important;" v-if="detail.statemember == 'active'">
                <v-icon slot="badge" dark small style=" font-size: 8px !important;cursor: pointer;" @click="uppic">
                  add_a_photo
                </v-icon>
                <v-avatar style="margin-top: 3vh;   border: 2px #1a222c !important; border-style:solid !important;" size="20vh">
                  <img v-if="detail.picture == ''" src='/static/img/default_profile/group-white.png' class="alligator-turtle" style="border: 2px #1a222c !important; border-style: solid !important; cursor: pointer;" @click="uppic">
                  <img v-else :src="detail.picture" class="alligator-turtle" @click="uppic"  style="border: 2px #1a222c !important; border-style:  solid !important; cursor: pointer;">
                  <div style="display: none;">
                    <input class="CSChatThai" type="file" name="file1" @change="previewImagegroup" accept="image/*" id="uploadpicturegroup"/>
                  </div>
                </v-avatar>
              </v-badge>
            </v-flex>
            <v-flex xs12 sm12 md12  style="justify-content: center;margin-top: 2vh;">
                  <div class="CSChatThai" v-if="!edit" style="width: 100%;">
                    {{$t('Dialog.group.groupName')}} : &nbsp;&nbsp;
                    <div  class="groupnameEdit" @click="editprofile()">&nbsp; {{detail.group_name}}
                      <div class="messageedit" style="color: #757575; font-size: 13px !important; cursor: pointer; float: right;" > <v-icon style="font-size: 10px;color: #757575;">settings</v-icon>
                      <!-- แก้ไข -->
                      {{$t('AnswerQuestion.edit')}}
                    </div>
                    </div>
                    </div>
                  <!-- </div> -->

                  <div class="CSChatThai" v-else style="width: 100%;" >
                    {{$t('Dialog.group.groupName')}} : &nbsp;&nbsp;
                      <input style="width: 100%" type="texteditgroup" :placeholder="$t('Dialog.group.groupName')" class="CSChatThai" v-model="nameedit">

                    <div style="width: 100%;    text-align: center;">
                      <v-btn dark  color="blue darken-1"  style="width: 19%;text-transform: none;" @click="changeprofile()">{{$t('AnswerQuestion.update')}}</v-btn>
                      <v-btn dark  style="width: 19%; background-color: #607d8b;text-transform: none;" @click="editprofile()">{{$t('AnswerQuestion.cancel')}}</v-btn>
                    </div>
                  </div>
              <!--   </v-card-title>
              </v-card> -->
            </v-flex>
          </v-layout>
        </v-container>
</v-card-text>
</v-card>
</v-dialog>
</template>
<script>
// import axios from 'axios'
// import { mapState } from 'vuex'
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'

export default {
  props: {dialogManageGroup: false, detail: ''},
  data: () => ({
    token: '',
    selectFile: '',
    imageData: '',
    picgroup: '',
    edit: false,
    nameedit: ''
  }),
  methods: {
    editprofile () {
      this.edit = !this.edit
      this.nameedit = this.detail.group_name
    },
    uppic () {
      $('#uploadpicturegroup').click()
    },
    closeManageGroup () {
      this.$emit('closeManageGroup', false)
      this.selectFile = ''
      this.imageData = ''
    },
    previewImage: function (event) {
      var input = event.target
      this.selectFile = event.target.files[0]
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = (e) => {
          this.imageData = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    previewImagegroup () {
      this.selectFile = event.target.files[0]
      if (this.selectFile !== '') {
        var uploadFile = new FormData()
        uploadFile.append('file', this.selectFile, this.selectFile.name)
        uploadFile.append('group_id', this.detail.group_id)
        uploadFile.append('tokenuser', this.token)
        this.axios.post(process.env.APImanage + '/setimagegroup', uploadFile).then((response) => {
          // console.log(response.data)
          if (response.data['status'] === 'success') {
            this.detail.picture = response.data.filename
            this.selectFile = ''
            document.querySelector('#uploadpicturegroup').value = ''
            this.$swal('', this.$t('Alert.Success.changePictureGroup'), 'success')
          } else {
            // console.log('fail')
            this.selectFile = ''
            document.querySelector('#uploadpicturegroup').value = ''
            this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
          }
        }, () => {
          this.selectFile = ''
          document.querySelector('#uploadpicturegroup').value = ''
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
        })
      }
    },
    changeprofile () {
      this.edit = !this.edit
      this.axios.post(process.env.APImanage + '/setnamegroup', {tokenuser: this.token, groupname: this.nameedit, group_id: this.detail.group_id}).then((response) => {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          this.detail.group_name = this.nameedit
          this.$swal('', this.$t('Alert.Success.renameGroup'), 'success')
        }
      }, () => {
        this.nameedit = this.detail.group_name
        this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
      })
    }
  },
  computed: {
    ...sync('*')
  },
  watch: {
    dialogManageGroup () {
      if (this.dialogManageGroup) {
      }
    }
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
  }
}
</script>
<style type="text/css" scoped>
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.fileInput {
  color: white;
}
.inputWrapper {
    height: 32px;
    width: 70px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    margin-top: 5vh;
    /*Using a background color, but you can use a background image to represent a button*/
    /*background-color: #DDF;*/
}

.crop {
    width: 200px;
    height: 150px;
    overflow: hidden;
}

.crop img {
    width: 400px;
    height: 300px;
    margin: -75px 0 0 -100px;
}
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
input[type=texteditgroup] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    /*background-image: url('../assets/image/group.png');*/
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 10px 10px 10px 10px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
}
.groupnameEdit:hover .messageedit {
  display: inline !important;
}
.groupnameEdit:hover  {
  background: rgb(195, 195, 195);
}

.groupnameEdit {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: rgb(224, 224, 224);
  height: 40px;
  padding: 9px;
  width: 100%;
  cursor: pointer;
  border-radius: 5px;
}
.messageedit {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/manage_group/ManageGroupDialog.vue